import { Entity } from "@dinahmoe/dmafjs-core";

class Sections extends Entity {
  namespace = "se26:sections";

  sectionOrder = ["home", "showcase", "connect"];

  handlers = {
    rootHeight: this.recalculate
  };

  init(node) {
    super.init(node);

    node._multipliers = {};
    for (const name of this.sectionOrder) {
      node._multipliers[name] = node[name];
    }

    this.recalculate(node);
  }

  recalculate(node) {
    const rootHeight = Math.max(node.rootHeight || 1, 600);
    for (const name of this.sectionOrder) {
      node[name] = node._multipliers[name] * rootHeight;
    }
  }
}

const sections = new Sections();
export { sections, Sections };
